module.exports = __webpack_public_path__ + "static/media/company_logo3.9ca631b9.png";